module.exports = "mutation ($id: ID!, $transferTo: ID!) {\n  UserDelete(id: $id, transferTo: $transferTo) {\n    id\n  }\n}\n"